import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TreoCardModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { AuthSignOutComponent } from 'app/modules/auth/sign-out/sign-out.component';
import { authSignOutRoutes } from 'app/modules/auth/sign-out/sign-out.routing';

@NgModule({
  declarations: [AuthSignOutComponent],
  imports: [CommonModule, RouterModule.forChild(authSignOutRoutes), MatButtonModule, TreoCardModule, SharedModule],
})
export class AuthSignOutModule {}
